import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  title: string | ((t: (key: string) => string) => string)
}

const PageTitle = ({ title }: Props) => {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    let resolvedTitle = ''
    if (typeof title === 'function') {
      resolvedTitle = title(t) || ''
    } else {
      resolvedTitle = title || ''
    }
    if (typeof resolvedTitle !== 'string') {
      resolvedTitle = String(resolvedTitle)
    }
    document.title = resolvedTitle
  }, [ title, i18n.language ])

  return null
}

export default PageTitle
